import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { Theme, ThemeProps } from '@theme/base';
import { Grid } from '@mui/material';
import { TestId } from '@components/test-ids';
import { ComponentContainer } from '@styles/layout';
import { mq } from '@styles/breakpoints';

export interface MediaEnquiriesComponentProps {
  theme?: Theme;
  testId?: string;
  description: string;
  title: string;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  marginBottom: -theme.custom.spacing.xxLarge,
  [mq.medium]: {
    marginBottom: -theme.custom.spacing.xxxLarge
  }
}));

const Section = styled.div(({ theme }: ThemeProps) => ({
  paddingBottom: theme.custom.spacing.xxLarge,
  borderBottom: `1px dashed ${theme.custom.colors.group10.base}`
}));

const SectionTitle = styled.h4(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any)
}));

const MediaEnquiriesComponent = (props: MediaEnquiriesComponentProps) => {
  const { title, description, theme } = props;

  return (
    <Container data-testid={props.testId || TestId.mediaEnquiries.main}>
      <Section>
        <SectionTitle>{title}</SectionTitle>
        <ComponentContainer noPadding spacing={theme!.custom.gridSpacing.default}>
          <Grid item>
            <p>{description}</p>
          </Grid>
        </ComponentContainer>
      </Section>
    </Container>
  );
};

export const MediaEnquiries = withTheme(MediaEnquiriesComponent);
